import * as React from 'react';
import * as styles from './AccreditationBanks.css';
import { bankIcons } from './assets';
import { Section } from '../Section';
import { TAccreditationBank } from '../../types/accreditationBanks';

interface IAccreditationBanksProps {
  banks: TAccreditationBank[];
}

export const AccreditationBanks: React.FC<IAccreditationBanksProps> = ({ banks }) => {
  const logos = React.useMemo(() => banks.map(bankName => bankIcons[bankName]).filter(Boolean), [banks]);

  if (!logos.length) {
    return null;
  }

  return (
    <Section title="Компания аккредитована" dataName="AccreditationBanks">
      <div className={styles['container']}>
        {logos.map((logo, index) => (
          <div key={index} className={styles['logo-container']}>
            <img src={logo} className={styles['logo']} />
          </div>
        ))}
      </div>
    </Section>
  );
};
